import React from 'react';
import styles from './styles.scss';

import earth from "../../../assets/media/icons/globe_big.png";
import earth_black from "../../../assets/media/icons/globe_black_big.png";
import { connect } from 'react-redux';
import {changeLocale} from "../../../actions/language";
import i18n from "../../../i18n";

export class LocalizatorUI extends React.Component {


    componentWillMount() {
        if (this.props.activeLanguage !== i18n.language) {
            i18n.changeLanguage(this.props.activeLanguage).then();
            this.props.changeLocale(this.props.locale, this.props.activeLanguage);
        }
    }


    changeLocale() {
        i18n.changeLanguage(this.props.locale).then();
       this.props.changeLocale(this.props.activeLanguage, this.props.locale);
    }


    render() {
        return <div className={styles.localizator}>
            <div className={styles.icon}
                 onClick={() => this.changeLocale()}>
                <img src={earth} alt='earth_icon' className={styles.iconImg}
                     onMouseOver = {e => (e.currentTarget.src = earth_black)}
                     onMouseOut = {e => (e.currentTarget.src = earth)}/>
            </div>
            <div className={styles.localeText}
                 onClick={() => this.changeLocale()}>
                {this.props.locale}
            </div>
        </div>
    }
}

export const Localizator = connect(
    store => ({
        locale: store.persistStore.language.locale,
        activeLanguage: store.persistStore.language.activeLanguage,
    }),
    dispatch => ({
        changeLocale(newLocale, newActiveLanguage) {
            dispatch(changeLocale(newLocale, newActiveLanguage));
        }
    })
)(LocalizatorUI);


// WEBPACK FOOTER //
// src/components/utils/localizator/index.jsx